export default {
  app: 'atom',
  api_prefix: '/atom-api',
  login_token_key: 'Atom-Token',
  login_user_key: 'Atom-USER',
  doc_path: '/atom-doc/index.html',
  logo_path: '/images/logos/logo.svg',
  main_site: 'https://www.baidu.com',
  footer: 'atom-系统框架',
  copyRight: '2025 因体信息公司',
};
